import imatgesIconaOctes from '../../images/octes';
import imatgesIconaVent from '../../images/vent';
import imatgesIconaMar from '../../images/mar';
import imatgesVisibilitat from '../../images/visibilitat';

export const variablesObservacions = {
	Temperatura: {
		paleta: [
			{
				condicions: [-50, -24],
				colorRGB: [175, 175, 173]
			},
			{
				condicions: [-24, -22],
				colorRGB: [127, 128, 126]
			},
			{
				condicions: [-22, -20],
				colorRGB: [93, 93, 92]
			},
			{
				condicions: [-20, -18],
				colorRGB: [0, 0, 168]
			},
			{
				condicions: [-18, -16],
				colorRGB: [66, 22, 202]
			},
			{
				condicions: [-16, -14],
				colorRGB: [80, 46, 189]
			},
			{
				condicions: [-14, -12],
				colorRGB: [93, 69, 175]
			},
			{
				condicions: [-12, -10],
				colorRGB: [110, 94, 160]
			},
			{
				condicions: [-10, -8],
				colorRGB: [100, 0, 100]
			},
			{
				condicions: [-8, -6],
				colorRGB: [126, 38, 126]
			},
			{
				condicions: [-6, -4],
				colorRGB: [155, 79, 155]
			},
			{
				condicions: [-4, -2],
				colorRGB: [186, 122, 186]
			},
			{
				condicions: [-2, 0],
				colorRGB: [205, 150, 205]
			},
			{
				condicions: [0, 2],
				colorRGB: [204, 255, 255]
			},
			{
				condicions: [2, 4],
				colorRGB: [164, 236, 239]
			},
			{
				condicions: [4, 6],
				colorRGB: [134, 216, 217]
			},
			{
				condicions: [6, 8],
				colorRGB: [106, 194, 209]
			},
			{
				condicions: [8, 10],
				colorRGB: [65, 157, 171]
			},
			{
				condicions: [10, 12],
				colorRGB: [1, 134, 45]
			},
			{
				condicions: [12, 14],
				colorRGB: [3, 194, 40]
			},
			{
				condicions: [14, 16],
				colorRGB: [0, 255, 64]
			},
			{
				condicions: [16, 18],
				colorRGB: [123, 241, 123]
			},
			{
				condicions: [18, 20],
				colorRGB: [201, 255, 148]
			},
			{
				condicions: [20, 22],
				colorRGB: [241, 242, 136]
			},
			{
				condicions: [22, 24],
				colorRGB: [241, 207, 101]
			},
			{
				condicions: [24, 26],
				colorRGB: [240, 171, 65]
			},
			{
				condicions: [26, 28],
				colorRGB: [240, 138, 31]
			},
			{
				condicions: [28, 30],
				colorRGB: [240, 107, 0]
			},
			{
				condicions: [30, 32],
				colorRGB: [255, 102, 102]
			},
			{
				condicions: [32, 34],
				colorRGB: [255, 70, 70]
			},
			{
				condicions: [34, 36],
				colorRGB: [255, 0, 0]
			},
			{
				condicions: [36, 38],
				colorRGB: [178, 34, 34]
			},
			{
				condicions: [38, 40],
				colorRGB: [155, 0, 0]
			},
			{
				condicions: [40, 42],
				colorRGB: [115, 0, 0]
			},
			{
				condicions: [42, 44],
				colorRGB: [79, 0, 0]
			},
			{
				condicions: [44, 46],
				colorRGB: [0, 0, 0]
			},
			{
				condicions: [46, 51],
				colorRGB: [175, 175, 173]
			}
		]
	},
	'Humitat relativa': {
		paleta: [
			{
				condicions: [0, 5],
				colorRGB: [120, 0, 0]
			},
			{
				condicions: [5, 10],
				colorRGB: [153, 0, 0]
			},
			{
				condicions: [10, 15],
				colorRGB: [204, 51, 0]
			},
			{
				condicions: [15, 20],
				colorRGB: [255, 0, 0]
			},
			{
				condicions: [20, 25],
				colorRGB: [255, 102, 102]
			},
			{
				condicions: [25, 30],
				colorRGB: [255, 102, 51]
			},
			{
				condicions: [30, 35],
				colorRGB: [255, 153, 51]
			},
			{
				condicions: [35, 40],
				colorRGB: [255, 204, 0]
			},
			{
				condicions: [40, 45],
				colorRGB: [255, 255, 0]
			},
			{
				condicions: [45, 50],
				colorRGB: [153, 255, 0]
			},
			{
				condicions: [50, 55],
				colorRGB: [0, 255, 0]
			},
			{
				condicions: [55, 60],
				colorRGB: [20, 204, 20]
			},
			{
				condicions: [60, 65],
				colorRGB: [0, 140, 0]
			},
			{
				condicions: [65, 70],
				colorRGB: [0, 255, 200]
			},
			{
				condicions: [70, 75],
				colorRGB: [0, 255, 255]
			},
			{
				condicions: [75, 80],
				colorRGB: [0, 150, 250]
			},
			{
				condicions: [80, 85],
				colorRGB: [0, 80, 255]
			},
			{
				condicions: [85, 90],
				colorRGB: [0, 0, 255]
			},
			{
				condicions: [90, 95],
				colorRGB: [100, 51, 204]
			},
			{
				condicions: [95, 101],
				colorRGB: [153, 0, 153]
			}
		]
	},
	Precipitacio: {
		paleta: [
			{
				condicions: [0, 0.2],
				colorRGB: [255, 255, 255]
			},
			{
				condicions: [0.2, 1],
				colorRGB: [170, 219, 250]
			},
			{
				condicions: [1, 5],
				colorRGB: [110, 192, 255]
			},
			{
				condicions: [5, 10],
				colorRGB: [66, 170, 255]
			},
			{
				condicions: [10, 20],
				colorRGB: [0, 149, 255]
			},
			{
				condicions: [20, 30],
				colorRGB: [0, 115, 255]
			},
			{
				condicions: [30, 40],
				colorRGB: [0, 76, 255]
			},
			{
				condicions: [40, 50],
				colorRGB: [0, 26, 255]
			},
			{
				condicions: [50, 75],
				colorRGB: [77, 26, 255]
			},
			{
				condicions: [75, 100],
				colorRGB: [122, 0, 245]
			},
			{
				condicions: [100, 150],
				colorRGB: [171, 0, 245]
			},
			{
				condicions: [150, 200],
				colorRGB: [196, 0, 245]
			},
			{
				condicions: [200, 10000],
				colorRGB: [245, 0, 245]
			}
		]
	},
	Neu: {
		paleta: [
			{
				condicions: [0, 1],
				colorRGB: [240, 240, 240]
			},
			{
				condicions: [1, 2],
				colorRGB: [49, 191, 247]
			},
			{
				condicions: [2, 5],
				colorRGB: [57, 139, 247]
			},
			{
				condicions: [5, 10],
				colorRGB: [52, 91, 247]
			},
			{
				condicions: [10, 15],
				colorRGB: [32, 43, 247]
			},
			{
				condicions: [15, 20],
				colorRGB: [53, 0, 245]
			},
			{
				condicions: [20, 25],
				colorRGB: [110, 0, 245]
			},
			{
				condicions: [25, 30],
				colorRGB: [155, 0, 245]
			},
			{
				condicions: [30, 40],
				colorRGB: [200, 0, 245]
			},
			{
				condicions: [40, 50],
				colorRGB: [245, 0, 245]
			},
			{
				condicions: [50, 60],
				colorRGB: [235, 117, 235]
			},
			{
				condicions: [60, 80],
				colorRGB: [230, 172, 230]
			},
			{
				condicions: [80, 601],
				colorRGB: [224, 224, 224]
			}
		]
	},
	Coberta: {
		tipus: 'icona',
		ampladaLlegendaEnPercentatge: 78,
		iconAnchor: [5, 10],
		paleta: [
			{
				condicions: 0,
				iconaURL: imatgesIconaOctes.octes8h_0,
				nom: '0 octes'
			},
			{
				condicions: 1,
				iconaURL: imatgesIconaOctes.octes8h_1,
				nom: '1 octes'
			},
			{
				condicions: 2,
				iconaURL: imatgesIconaOctes.octes8h_2,
				nom: '2 octes'
			},
			{
				condicions: 3,
				iconaURL: imatgesIconaOctes.octes8h_3,
				nom: '3 octes'
			},
			{
				condicions: 4,
				iconaURL: imatgesIconaOctes.octes8h_4,
				nom: '4 octes'
			},
			{
				condicions: 5,
				iconaURL: imatgesIconaOctes.octes8h_5,
				nom: '5 octes'
			},
			{
				condicions: 6,
				iconaURL: imatgesIconaOctes.octes8h_6,
				nom: '6 octes'
			},
			{
				condicions: 7,
				iconaURL: imatgesIconaOctes.octes8h_7,
				nom: '7 octes'
			},
			{
				condicions: 8,
				iconaURL: imatgesIconaOctes.octes8h_8,
				nom: '8 octes'
			}
		]
	},
	Vent: {
		tipus: 'icona',
		ampladaLlegendaEnPercentatge: 91,
		iconAnchor: [15, 19],
		paleta: [
			{
				condicions: 0,
				iconaURL: imatgesIconaVent.força_0,
				nom: 0
			},
			{
				condicions: 1,
				iconaURL: imatgesIconaVent.força_1,
				nom: 1
			},
			{
				condicions: 2,
				iconaURL: imatgesIconaVent.força_2,
				nom: 2
			},
			{
				condicions: 3,
				iconaURL: imatgesIconaVent.força_3,
				nom: 3
			},
			{
				condicions: 4,
				iconaURL: imatgesIconaVent.força_4,
				nom: 4
			},
			{
				condicions: 5,
				iconaURL: imatgesIconaVent.força_5,
				nom: 5
			},
			{
				condicions: 6,
				iconaURL: imatgesIconaVent.força_6,
				nom: 6
			},
			{
				condicions: 7,
				iconaURL: imatgesIconaVent.força_7,
				nom: 7
			},
			{
				condicions: 8,
				iconaURL: imatgesIconaVent.força_8,
				nom: 8
			},
			{
				condicions: 9,
				iconaURL: imatgesIconaVent.força_9,
				nom: 9
			},
			{
				condicions: 10,
				iconaURL: imatgesIconaVent.força_10,
				nom: 10
			},
			{
				condicions: 11,
				iconaURL: imatgesIconaVent.força_11,
				nom: 11
			},
			{
				condicions: 12,
				iconaURL: imatgesIconaVent.força_12,
				nom: 12
			},
			{
				condicions: -999,
				iconaURL: imatgesIconaVent.força_no_representable,
				nom: 'No representable'
			}
		]
	},
	Mar: {
		tipus: 'icona',
		ampladaLlegendaEnPercentatge: 86,
		iconAnchor: [4, 18],
		iconSize: [30, 22],
		paleta: [
			{
				condicions: 'Mar plana (0 m)',
				iconaURL: imatgesIconaMar.estat_50,
				nom: 'Mar plana'
			},
			{
				condicions: 'Mar arrissada (0 a 0,1 m)',
				iconaURL: imatgesIconaMar.estat_51,
				nom: 'Mar arrissada'
			},
			{
				condicions: 'Marejol (0,1 a 0,5 m)',
				iconaURL: imatgesIconaMar.estat_52,
				nom: 'Marejol'
			},
			{
				condicions: 'Maror (0,5 a 1,25 m)',
				iconaURL: imatgesIconaMar.estat_53,
				nom: 'Maror'
			},
			{
				condicions: 'Forta maror (1,25 a 2,5 m)',
				iconaURL: imatgesIconaMar.estat_54,
				nom: 'Forta maror'
			},
			{
				condicions: 'Maregassa (2,5 a 4,0 m)',
				iconaURL: imatgesIconaMar.estat_55,
				nom: 'Maregassa'
			},
			{
				condicions: 'Mar brava (4,0 a 6,0 m)',
				iconaURL: imatgesIconaMar.estat_56,
				nom: 'Mar brava'
			},
			{
				condicions: 'Mar desfeta (6,0 a 9,0 m)',
				iconaURL: imatgesIconaMar.estat_57,
				nom: 'Mar desfeta'
			},
			{
				condicions: 'Mar molt alta (9,0 a 14,0 m)',
				iconaURL: imatgesIconaMar.estat_58,
				nom: 'Mar molt alta'
			},
			{
				condicions: 'Mar enorme (més de 14,0 m)',
				iconaURL: imatgesIconaMar.estat_59,
				nom: 'Mar enorme'
			}
		]
	},
	Visibilitat: {
		tipus: 'icona',
		ampladaLlegendaEnPercentatge: 78,
		iconAnchor: [10, 11],
		iconSize: [30, 22],
		paleta: [
			{
				condicions: 'Excel·lent (> 50 km)',
				iconaURL: imatgesVisibilitat.visibilitat1,
				nom: 'Excel·lent (> 50 km)'
			},
			{
				condicions: 'Bona (10 a 50 km)',
				iconaURL: imatgesVisibilitat.visibilitat2,
				nom: 'Bona (10 a 50 km)'
			},
			{
				condicions: 'Regular (1 a 10 km)',
				iconaURL: imatgesVisibilitat.visibilitat3,
				nom: 'Regular (1 a 10 km)'
			},
			{
				condicions: 'Dolenta (< 1 km)',
				iconaURL: imatgesVisibilitat.visibilitat4,
				nom: 'Dolenta (< 1 km)'
			},
			{
				condicions: "Molt dolenta (< 0'5 km)",
				iconaURL: imatgesVisibilitat.visibilitat5,
				nom: "Molt dolenta (< 0'5 km)"
			}
		]
	}
};



// WEBPACK FOOTER //
// ./src/components/commons/paletesColors.js